exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-base-page *[data-v-8122e770]{pointer-events:auto}.ps-page[data-v-8122e770]{-webkit-transition:all .35s ease;transition:all .35s ease;will-change:transform;-webkit-transform:translateY(calc(100% + 2rem));transform:translateY(calc(100% + 2rem))}.ps-page.ps-is-active[data-v-8122e770]{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transition-delay:.2s;transition-delay:.2s}", ""]);

// exports
